var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("商品待入库列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.resData
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "start"
              }
            },
            _vm._l(_vm.resData.optionsOrigin, function(item) {
              return item.key !== -1
                ? _c(
                    "div",
                    {
                      key: item.key,
                      staticClass: "status",
                      class: { active: _vm.origin === item.key },
                      on: {
                        click: function($event) {
                          return _vm.selectOrigin(item.key)
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "输入搜索：" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商品货号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_no", $$v)
                                        },
                                        expression: "form.goods_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "sku" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.sku,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "sku", $$v)
                                        },
                                        expression: "form.sku"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商品名称" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_name", $$v)
                                        },
                                        expression: "form.goods_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商家" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.supply_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "supply_name", $$v)
                                        },
                                        expression: "form.supply_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "市场" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.market_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "market_name", $$v)
                                        },
                                        expression: "form.market_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "品牌" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.brand_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "brand_name", $$v)
                                        },
                                        expression: "form.brand_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.resData
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "选择代采组"
                                            },
                                            model: {
                                              value: _vm.form.pgid,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "pgid", $$v)
                                              },
                                              expression: "form.pgid"
                                            }
                                          },
                                          _vm._l(
                                            _vm.resData.optionsPg,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.key
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.resData
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "选择买手组"
                                            },
                                            model: {
                                              value: _vm.form.picker_group,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "picker_group",
                                                  $$v
                                                )
                                              },
                                              expression: "form.picker_group"
                                            }
                                          },
                                          _vm._l(
                                            _vm.resData.optionsMs,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.key
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.resData
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "订单负责人"
                                            },
                                            model: {
                                              value: _vm.form.order_owner,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "order_owner",
                                                  $$v
                                                )
                                              },
                                              expression: "form.order_owner"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.owner_option,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    value: item.value,
                                                    label: item.label
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择入库来源" },
                                        model: {
                                          value: _vm.form.type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "type", $$v)
                                          },
                                          expression: "form.type"
                                        }
                                      },
                                      _vm._l(_vm.resData.optionsType, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "次品组"
                                        },
                                        model: {
                                          value: _vm.form.dgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dgid", $$v)
                                          },
                                          expression: "form.dgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.resData.dg_group, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "退换货负责人"
                                        },
                                        model: {
                                          value: _vm.form.dpc_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dpc_id", $$v)
                                          },
                                          expression: "form.dpc_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.resData.option_dgm, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "售后退供员"
                                        },
                                        model: {
                                          value: _vm.form.refunder_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "refunder_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.refunder_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.dgm_refunder,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { padding: "0 25px" } },
                      [
                        _vm.resData
                          ? _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "打标时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择仓库" },
                                        model: {
                                          value: _vm.form.origin,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "origin", $$v)
                                          },
                                          expression: "form.origin"
                                        }
                                      },
                                      _vm._l(
                                        _vm.resData.optionsOrigin,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.resData
            ? _c(
                "el-col",
                { staticClass: "data-statics", attrs: { span: 24 } },
                [
                  _vm._v(
                    "\n      数据汇总    待入库总数" +
                      _vm._s(_vm.resData.count) +
                      "件        待入库金额：¥" +
                      _vm._s(_vm.resData.stock_total_price) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [_vm._v("数据列表：")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: {
                          disabled: _vm.reCallButtonDisabled,
                          size: "mini",
                          type: "danger"
                        },
                        on: { click: _vm.reCallDbids }
                      },
                      [_vm._v("删除")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.oweRebackApply }
                      },
                      [_vm._v("\n          申请恢复欠货\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "600",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "right",
                                type: "selection",
                                width: "55"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dbid",
                                label: "打标id",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_img",
                                label: "商品图片",
                                width: "120",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "viewer",
                                                rawName: "v-viewer"
                                              }
                                            ],
                                            staticStyle: {
                                              width: "40px",
                                              height: "40px",
                                              overflow: "hidden",
                                              cursor: "pointer",
                                              margin: "auto"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: {
                                                src: scope.row.goods_img
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1325509903
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _vm.where === 3
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "blp_img",
                                    label: "换回商品图片",
                                    width: "120",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "viewer",
                                                    rawName: "v-viewer"
                                                  }
                                                ],
                                                staticStyle: {
                                                  width: "40px",
                                                  height: "40px",
                                                  overflow: "hidden",
                                                  cursor: "pointer",
                                                  margin: "auto"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "100%",
                                                    height: "100%"
                                                  },
                                                  attrs: {
                                                    src: scope.row.blp_img
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3270613857
                                  )
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "商品货号",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sku",
                                label: "sku",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "da_biao_record_stock_source",
                                label: "入库来源",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "da_biao_record_type",
                                label: "类型",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "market_name",
                                label: "市场",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "supply_name",
                                label: "商家",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pg_name",
                                label: "买手组",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pgname",
                                label: "代采组",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "owner_admin_name",
                                label: "订单负责人",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dg_group_name",
                                label: "次品组",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dgm_name",
                                label: "退换货负责人",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "refunder",
                                label: "售后退供员",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "origin",
                                label: "仓库",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_admin",
                                label: "打标人",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "打标时间",
                                width: "100",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      {
                        staticStyle: { "text-align": "right", padding: "25px" }
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.curPage,
                            background: "",
                            layout: "total, prev, pager, next, jumper,sizes ",
                            total: _vm.resData.count,
                            "page-size": _vm.form.page_sizes,
                            "page-sizes": [10, 20, 50, 100]
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.curPage = $event
                            },
                            "update:current-page": function($event) {
                              _vm.curPage = $event
                            },
                            "current-change": _vm.handleCurrentChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申恢复欠货",
            visible: _vm.isShowRebackDialog,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowRebackDialog = $event
            },
            close: function($event) {
              _vm.isShowRebackDialog = false
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "80px" } },
            [
              _c("el-form-item", { attrs: { label: "申请数量: " } }, [
                _vm._v(_vm._s(_vm.form.multipleSelection.length))
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "申请说明: " } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 6 },
                    model: {
                      value: _vm.oweRebackApplyRemark,
                      callback: function($$v) {
                        _vm.oweRebackApplyRemark = $$v
                      },
                      expression: "oweRebackApplyRemark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.isShowRebackDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.doApplyReback }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72eaa0ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72eaa0ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/WarehousingList.vue
// module id = null
// module chunks = 